/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
* A service which handles push notification permission for the current user.
*/
angular.module('bulbApp.pushNotificationModule')
.service('PushNotificationService', ['BulbBusyService', 'BulbErrorService', 'Restangular', PushNotificationService]);

function PushNotificationService(BulbBusyService, BulbErrorService, Restangular) {

  var that = this;

  /**
   * It checks whether the user has granted the permission
   * @param permissionData
   * @param userId
   */
  this.checkRemotePermission = function (permissionData, account, accountSettingsForm) {

    if (permissionData.permission === 'default') {
      window.safari.pushNotification.requestPermission(
        CONFIG.base.url + '/b/rest/accounts', // The web service URL.
        CONFIG.pushnotification.apns.safari.webPushId,     // The Website Push ID.
        {'id': account.id}, // the userId.
        this.checkRemotePermission
      );
    } else if (permissionData.permission === 'denied') {
      // The user said no.
    } else if (permissionData.permission === 'granted') {
      // The web service URL is a valid push provider, and the user said yes.
      // permissionData.deviceToken is now available to use.
      var patch = {};
      patch = {deviceToken: permissionData.deviceToken};
      if(account.deviceTokens) {
        that.sendAccountUpdate(account, patch, accountSettingsForm);
      }
    }
  };

  /**
   * Checks the Safari browser version
   * @returns {Number} The version of Safari Browser
   */
  this.checkBrowserVersion = function () {
    var safariFullVersion = navigator.userAgent.substring(navigator.userAgent.indexOf('Version')+8);
    safariFullVersion = safariFullVersion.substring(0,safariFullVersion.indexOf(' '));
    var safariMajorVersion = parseInt(''+safariFullVersion,10);
    return safariMajorVersion;
  };

  /**
   * Send update request to the server.
   */
  this.sendAccountUpdate = function(account, patch, accountSettingsForm) {
    BulbBusyService.showBusyDuring(
      Restangular.one('accounts', account.id).patch(patch).then(function () {

      }, function(error) {

        if (error.data.errorMap) {
          // allow the form controller to handle field validation errors:
          accountSettingsForm.handleRemoteErrors(error);
        } else {
          BulbErrorService.showError(null, error);
        }

      })
    );
  };
}


